const ERROR_STATES = {
  OTP_INVALID: {
    kind: "expired-code",
    title: "Code expired or incorrect",
    message: "Request a new code, then enter the latest code from your email.",
    canResend: true,
  },
  OTP_RESEND_COOLDOWN: {
    kind: "resend-wait",
    title: "A code was sent recently",
    message:
      "Wait for the resend timer, then request another code if it has not arrived.",
  },
  ACCOUNT_SUSPENDED: {
    kind: "suspended-account",
    title: "Account suspended",
    message:
      "Access is paused for this account. Contact your event organizer or PhotoX support.",
  },
  ACCOUNT_DISABLED: {
    kind: "suspended-account",
    title: "Account disabled",
    message:
      "This account cannot sign in. Contact your event organizer or PhotoX support.",
  },
  ADMIN_LOGIN_REQUIRED: {
    kind: "admin-only",
    title: "Use the Admin sign-in",
    message:
      "Administrator accounts are isolated from the shared Client, Photographer and Guest login.",
  },
  AUTH_RATE_LIMITED: {
    kind: "rate-limited",
    title: "Too many sign-in attempts",
    message: "Please wait before trying again.",
  },
};

export function describeLoginError(error) {
  const known = ERROR_STATES[error?.code];
  if (known) return { ...known, code: error.code };
  return {
    kind: "request-error",
    title: "We could not complete sign-in",
    message: error?.message || "Check your connection and try again.",
    code: error?.code || "UNKNOWN",
  };
}

export function secondsRemaining(deadline, now = Date.now()) {
  const value = new Date(deadline || 0).getTime();
  if (!Number.isFinite(value) || value <= now) return 0;
  return Math.ceil((value - now) / 1000);
}

export function otpTiming(result, now = Date.now()) {
  const cooldown = Math.max(0, Number(result?.resendAfterSeconds) || 0);
  const expiresAt = new Date(result?.expiresAt || 0).getTime();
  return {
    resendAt: now + cooldown * 1000,
    expiresAt: Number.isFinite(expiresAt) ? expiresAt : 0,
  };
}
